export default __webpack_public_path__ + "static/media/marketplace_eclinic_final.022b44d4.webm";